import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Moment from 'moment';
import ProgressPhotosAdd from './ProgressPhotosAdd';
import { getClientProgressPhotosSummary } from '../ducks/ProgressActions';

const ProgressPhotos = ({
  clientId,
  getClientProgressPhotosSummary,
  progressImagesSummary
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    getClientProgressPhotosSummary(clientId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, modalOpen]);

  if (!progressImagesSummary) return 'Loading...';

  function getDate(date) {
    if (!date) return '';
    return date.toDate ? Moment(date.toDate()).format('MM/DD/YYYY') : '';
  }

  return (
    <div className="photos">
      <header>
        <h5>Photos</h5>
        <Link hidden={!progressImagesSummary[0]} to={`/clients/${clientId}/progress-photos`}>See All</Link>
      </header>
      <div className="progress-img">
        {!!progressImagesSummary[0] && (
          <div>
            <img src={progressImagesSummary[0]?.images?.front} alt="Progress" />
            <span>Start: {getDate(progressImagesSummary[0]?.created_at)}</span>
          </div>
        )}

        {!!progressImagesSummary[1] && (
          <div>
            <img src={progressImagesSummary[1]?.images?.front} alt="Progress" />
            <span>Latest: {getDate(progressImagesSummary[1]?.created_at)}</span>
          </div>
        )}
        <div className="add-more">
          <span className="clickable" onClick={() => setModalOpen(true)}>
            <i className="fas fa-plus"></i>
          </span>
        </div>
      </div>
      <ProgressPhotosAdd
        clientId={clientId}
        openModal={modalOpen}
        setModalOpen={setModalOpen}
      />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    progressImagesSummary: state.progressReducer.progressImagesSummary
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClientProgressPhotosSummary: clientId =>
      dispatch(getClientProgressPhotosSummary(clientId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgressPhotos);
